import _ from 'underscore';
import koSchema from '@bingads-webui-component-legacy/ko-schema/index';
import BaseTargetViewModel from '@bingads-webui-campaign-legacy/base-targets/viewmodel/baseTargets';
import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';

export default class AgeViewModel extends BaseTargetViewModel {
  constructor(options = {}) {
    super(_.defaults({
      targetTypePrefix: 'AgeType',
      targetRowKeys: targetConstants.rowKeys.Age,
      criterionType: 'Age',
      criterionTypeTarget: 'Target',
      MTBidAdjustmentErrorCode: 'CampaignServiceInvalidAgeTargetBidAdjustment',
      MTBidAdjustmentErrorNumber: '2936',
    }, options));

    koSchema.properties(this);
  }
}
